// js/supabase-config.js

// 1. Importa a função createClient do pacote local instalado via NPM.
import { createClient } from '@supabase/supabase-js';

// Substitua pelos valores do seu projeto no Supabase
const SUPABASE_URL = 'https://ljndpqobfdphzgtfqwdp.supabase.co';
const SUPABASE_ANON_KEY = 'sb_publishable_joVDuY7pb-_IZewUm9xteg_hoAFHEos';

// 3. Validação para garantir que as credenciais foram inseridas
if (!SUPABASE_URL || !SUPABASE_ANON_KEY || SUPABASE_URL.includes('SUA_URL')) {
    const errorMessage = 'As credenciais do Supabase (URL e Chave) não foram definidas corretamente em js/supabase-config.js. Por favor, insira seus dados do projeto.';
    // Mostra o erro no console e também na página para o desenvolvedor ver.
    document.querySelector('#app-root').innerHTML = `<h1 style="color:red;padding:2rem;">Erro de Configuração</h1><p style="padding: 0 2rem;">${errorMessage}</p>`;
    throw new Error(errorMessage);
}

// Cria e exporta o cliente Supabase para ser usado em todo o site
const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);

export default supabase;